import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { UserComponent } from '@routes/users/user/user.component';
import { TicketViewsComponent } from '@routes/tickets/ticket-views/ticket-views.component';
import { DealerComponent } from '@routes/dealers/dealer/dealer.component';
import { SummaryComponent } from '@routes/summary/summary.component';
import { PaymentsComponent } from '@routes/payments/payments.component';
import { PlaceComponent } from '@routes/purchase-place/place/place.component';
import { ZipCodeComponent } from '@routes/b2b/zip-code-list/zip-code/zip-code.component';

@Component({
  selector: 'app-main-layout-template',
  template: '<ng-container #container></ng-container>'
})
export class MainLayoutTemplateComponent {
  componentRef: any;
  // FIXME Component Mapping Information
  readonly viewTemplateMapper = {
    tickets: TicketViewsComponent,
    users: UserComponent,
    dealers: DealerComponent,
    summary: SummaryComponent,
    payments: PaymentsComponent,
    purchasePlace: PlaceComponent,
    zipCode: ZipCodeComponent,
  }
  @ViewChild('container', { read: ViewContainerRef }) private container: ViewContainerRef;

  constructor() {
  }

  @Input()
  set selectedComponent(value) {
    if (value) {
      this.loadComponent(value);
    }
  }

  private loadComponent(component: any) {
    const viewContainerRef = this.container;
    if (viewContainerRef) {
      viewContainerRef.clear();
    }

    const viewTemplateMapperElement = this.viewTemplateMapper[component];
    if (!component || !viewTemplateMapperElement) {
      return;
    }

    this.componentRef = viewContainerRef.createComponent(viewTemplateMapperElement);
    const inst: any = this.componentRef.instance;
    inst.componentId = component;
  }
}
